import React, { Component } from 'react';
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import ToggleButton from 'react-toggle-button'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
class ListWhitelist extends Component {
	constructor(props) {
		super(props);
		this.state = {
			whitelist: [],
			confirmDelete: false,
			selectedBlId: 0,
			sizePerPage: 10,
			selectedMobile : '',
			loading: true
		}
	}
	componentDidMount() {
		this.getWhitelist();
		const savedSizePerPage = Cookies.get('voiceWhitelistListsizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}

	getWhitelist = () => {
		const apiPath = this.props.app.apiPath;
		const userId = this.props.app.userId;
		this.setState({ loading: true });
		Fetcher.get(apiPath + '/api/obd/whitelist/'+userId)
			.then(res => {
				this.setState({
					whitelist: res,
					confirmDelete: false,
					loading: false,
				})
			})
			.catch(err => { console.log('Error in fetching Whitelist Numbers', err); this.setState({ loading: false }); });
	}

	confirmDelete = (status, mobile) => {
		this.setState({
			confirmDelete: status,
			selectedMobile: mobile
		});
	}

	deleteWhitelist = () => {
		const mobile = this.state.selectedMobile;
		const userId = this.props.app.userId;
		const data = {
                "mobile" : mobile,
				"userId" : userId,
				"operation": "remove"
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/superadmin/delete/Whitelist', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getWhitelist();
			})
			.catch(err => {
				console.log('Error in Deleting whitelist Number', err);
			});
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('voiceWhitelistListsizePerPage', newSizePerPage);
	}

	render() {

		const whitelist = this.state.whitelist;
		let columns = '';
		
			columns = [
			{
				dataField: 'whitelistId',
				text: 'Whitelist Id.',
				sort: true,
				hidden: false
			},
			{
				dataField: 'mobile',
				text: 'Mobile',
				sort: true,
				searchable: true
			}, {
				dataField: 'reqDate',
				text: 'Request Date',
				sort: false,
				searchable: false
			}, {
				dataField: 'action',
				text: 'Action',
				sort: false,
				searchable: false
			},];

		const products = Array.isArray(whitelist) ? whitelist.map((blist, index) => {
			
			let action = [];
			if (this.props.app.hasPermission('Number Action.View Whitelist', 'delete')) {
				action.push(<a data-tip="Delete Whitelist" key={`${index}-delete-bl`} className="delete-bl" onClick={(e) => { this.confirmDelete(true, blist.mobile) }} href="#"><i className="fa fa-trash"></i></a>)
			}
			return {
				whitelistId: blist.whitelistId,
				mobile: blist.mobile,
				reqDate: blist.reqDate,
				action: action
			};
		}) : []
		const { SearchBar, ClearSearchButton } = Search;

		const defaultSorted = [{
			dataField: 'whitelistId',
			order: 'desc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: products.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		return (
			<Card>
				<Card.Header>Whitelist</Card.Header>
				<Card.Body>
					<div className="campaign-list-table-cont">
						{<PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (<ToolkitProvider keyField="whitelistId" data={products} columns={columns} search bootstrap4>
									{props => (<div className="">
										Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
										<span className="search-cont"><SearchBar {...props.searchProps} /></span>
										<ClearSearchButton className="btn-primary" {...props.searchProps} />
										<hr/>
										<BootstrapTable bordered={true} hover condensed defaultSorted={defaultSorted} wrapperClasses="table-responsive" classes="blacklist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
										<PaginationListStandalone {...paginationProps} />
									</div>)}
								</ToolkitProvider>)
							}
						</PaginationProvider>}
					</div>
					<Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Delete Whitelist
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to delete this number from whitelist?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.deleteWhitelist} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>
					{this.state.loading && <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>}
				</Card.Body>
			</Card>
		);
	}
}


export default ListWhitelist;